import { useEffect, useRef, useState } from 'react';
import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAuth } from 'src/contexts/auth';

import { ModelOfNegocio, ModelOfFuelType, ModelOfTipoCombustivel, ModelOfContrato, ModelOfVehicleItem } from '../../database';
import api from '../../services/api';
import { ModelOfAbastecimento } from 'src/modelreport/relabastecimento';
import { Toast } from 'primereact/toast';

const initialValuesOfNegocio = {
	ID: '',
	ORGAO: '',
	CNPJ: '',
	RAZAOSOCIAL: '',
	ENDERECO: '',
	CEP: '',
	BAIRRO: '',
	MUNICIPIO: '',
	EMAIL: '',
};

export const useListNegociosController = () => {
	const [NegociosData, setNegociosData] = useState<ModelOfNegocio[]>([]);
	const [selectedNegocio, setSelectedNegocio] = useState<ModelOfNegocio>(initialValuesOfNegocio);
	const [loading, setLoading] = useState(false);
	const [loadingEdit, setLoadingEdit] = useState(false);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);
	const toast: any = useRef();
	const { userAgencyId } = useAuth();


	const validationSchema = Yup.object().shape({
		ID: Yup.string(),
		ORGAO: Yup.string().required('* Campo obrigatório'),
		CNPJ: Yup.string().required('* Campo obrigatório'),
		RAZAOSOCIAL: Yup.string().required('* Campo obrigatório'),
		ENDERECO: Yup.string(),
		CEP: Yup.string(),
		BAIRRO: Yup.string(),
		MUNICIPIO: Yup.string(),
		EMAIL: Yup.string(),

	});

	const getNegocios = () => {
		setLoading(true);

		api.get(`/negocios2/${userAgencyId}`)
			.then(response => {

				if (response.status === 204) {
					setLoading(false);
				} else {
					console.log("response ---", response)
					setNegociosData(
						NegociosData.concat(
							response.data.filter((item: any) => {
								return item.ORGAO === userAgencyId;
							}),
						),
					);
					setLoading(false);
				}
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
			});
	};

	const removeNegocio = async (Negocio: ModelOfNegocio) => {
		setLoading(true);
		api.delete(`negocios/${Negocio.ID}`)
			.then(response => {
				const newList = NegociosData.filter(creditor => creditor.ID !== response.data.ID);
				setNegociosData(newList);
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'O credor foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(() => {
				getNegocios();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editNegocio = async (Negocio: ModelOfNegocio) => {
		setLoadingEdit(true);
		const editedNegocio: ModelOfNegocio = {
			...Negocio,
		};
		api.put(`negocios/${selectedNegocio?.ID}`, editedNegocio)
			.then(() => {
				getNegocios();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'O credor foi editada com sucesso!',
					life: 5000,
				});
				setTimeout(() => {
					window.location.reload();
				}, 1500);
			})
			.catch(err => {
				getNegocios();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação! ' + err,
					life: 5000,
				});
			});
	};



	const openDeleteDialog = (Negocio: ModelOfNegocio) => {
		setDeleteDialog(true);
		setSelectedNegocio(Negocio);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (Negocio: ModelOfNegocio) => {
		setEditDialog(true);
		setSelectedNegocio(Negocio);
	};

	const criarFatura = async ({idOrgaoUnidade, dataInicio, dataFim, negocio, contrato, vehicleData, toast }: {idOrgaoUnidade:string, dataInicio: string; dataFim: string; negocio: ModelOfNegocio; contrato: ModelOfContrato; vehicleData: ModelOfAbastecimento[]; toast: React.RefObject<Toast>; }) => {
		setLoading(true);
		console.log("  --->>> Criando fatura com os seguintes dados:", {
			idOrgaoUnidade,
			dataInicio,
			dataFim,
			negocio,
			contrato,
			vehicleData,
		});
		try {
			await api.post('faturas/', {
				idOrgaoUnidade: idOrgaoUnidade,
				dataInicio: dataInicio,
				dataFim: dataFim,
				userAgencyId: userAgencyId,
				negocio: negocio,
				contrato: contrato,
				abastecimentos: vehicleData,
			});
			toast.current?.show({
				severity: 'success',
				summary: 'Fatura criada',
				detail: 'A fatura foi criada com sucesso!',
				life: 5000,
			});
		} catch (error) {
			toast.current?.show({
				severity: 'error',
				summary: 'Falha ao criar fatura',
				detail: 'Ocorreu um erro ao criar a fatura! ' + error,
				life: 5000,
			});
		} finally {
			setLoading(false);
		}
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};


	const formik = useFormik<ModelOfNegocio>({

		initialValues: {
			ID: '',
			ORGAO: '',
			CNPJ: '',
			RAZAOSOCIAL: '',
			ENDERECO: '',
			CEP: '',
			BAIRRO: '',
			MUNICIPIO: '',
			EMAIL: '',
		},
		validationSchema: validationSchema,
		onSubmit: async (values) => {
			console.log("valores: ", values)
			await editNegocio(values)
		}

	});



	useEffect(() => {
		console.log("1111111 getNegocios")
		getNegocios();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		getNegocioListController: {
			formik,
			NegociosData,
			selectedNegocio,
			loading,
			deleteDialog,
			editDialog,
			loadingEdit,
			toast,
		},
		handleNegocioListController: {
			removeNegocio,
			editNegocio,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
			getNegocios,
			criarFatura,
		},
	};
};
